import NewsNew from './NewsNew';

export default NewsNew;
